import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sustain',
    templateUrl: './sustain.component.html',
    styleUrls: ['./sustain.component.less'],
    standalone: false
})
export class SustainComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
